import { EmailAutomationTriggers } from './emailAutomations';

const PolicyListTokens = [
  '{{{compliant_policies}}}',
  '{{{expired_policies}}}',
  '{{{non_compliant_policies}}}',
  '{{{not_received_policies}}}',
  '{{{pending_policies}}}',
  '{{{policies_expiring_in_30_days}}}',
  '{{{waived_policies}}}'
];

const DocumentTokens = [
  '{{{compliant_documents}}}',
  '{{{current_documents}}}',
  '{{{documents_expiring_in_30_days}}}',
  '{{{expired_documents}}}',
  '{{{non_compliant_documents}}}',
  '{{{not_received_documents}}}',
  '{{{pending_documents}}}',
  '{{{waived_documents}}}',
  '{{{waived_document_requirements}}}',
  '{{{all_document_requirements}}}'
];

const AttachmentTokens = [
  '{{{project_attachments}}}',
  '{{{record_attachments}}}'
];

const CompanyTokens = [
  '{{cert_holder_company_name}}',
  '{{department_name}}',
  '{{insured_company_name}}',
  '{{insured_contact_name}}',
  '{{insured_description}}',
  '{{insured_external_id}}',
  '{{insured_notes}}',
  '{{project_description}}',
  '{{project_external_id}}',
  '{{project_name}}',
  '{{project_number}}'
];

const RecordTokens = [
  '{{record_description}}',
  '{{record_external_id}}',
  '{{record_number}}'
];

const UserTokens = [
  '{{user_name}}',
  '{{user_email}}',
  '{{user_phone}}',
  '{{user_fax}}',
  '{{user_company}}'
];

const ItemTokens = [
  '{{{items_with_codes}}}'
];

const AutomationPolicyTokens = [
  '{{policy_types}}',
  '{{policy_numbers}}',
  '{{policy_expiration_date}}',
  '{{{automation_policy_list}}}'
];

const AutomationDocumentTokens = [
  '{{{automation_document_list}}}'
];

const AutomationTokens = [
  '{{automation_name}}',
  '{{automation_time_frame_verb}}'
];

export const DefaultTemplateTokens = {
  Company: CompanyTokens,
  Documents: DocumentTokens,
  Attachments: AttachmentTokens,
  Items: ItemTokens,
  Policies: PolicyListTokens,
  Record: RecordTokens,
  User: UserTokens
};

export const EmailAutomationTokens = {
  [EmailAutomationTriggers.PolicyExpiration]: {
    Policy: AutomationPolicyTokens,
    Document: AutomationDocumentTokens,
    Attachment: AttachmentTokens,
    Company: CompanyTokens,
    Automation: AutomationTokens,
    User: UserTokens
  }
};
